<template>
  <div class="text-center">
    <p>{{params.data.patient.dob ? calculateAge(params.data.patient.dob) : 'N/A'}} </p>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  methods: {
    calculateAge(dob){
        var birth_year = dob.substring(0,4),
        birth_month = dob.substring(5,7),
        birth_day = dob.substring(8,10);
        
        var today_date = new Date(),
        today_year = today_date.getFullYear(),
        today_month = today_date.getMonth(),
        today_day = today_date.getDate(),
        age = today_year - birth_year;

        if ( today_month < (birth_month - 1))
        {
            age--;
        }
        if (((birth_month - 1) == today_month) && (today_day < birth_day))
        {
            age--;
        }
        return age;
    },
  },
  computed: {
    
  }
}
</script>
